// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";

import { getFirestore } from "firebase/firestore";
import { getFunctions } from "firebase/functions";

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyA4dDGFZID5KFEoRqy69lXnUhd_jUATTkE",
  authDomain: "paper-voter.firebaseapp.com",
  projectId: "paper-voter",
  storageBucket: "paper-voter.firebasestorage.app",
  messagingSenderId: "1028729248045",
  appId: "1:1028729248045:web:446e522f9b910a1cd9dba4",
  measurementId: "G-JJ4W3LJX99"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
const functions = getFunctions(app);  // 👈 this enables callable functions

// Export Firestore
const db = getFirestore(app);
export { db, functions };
